var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 44,
    viewBox: "0 0 223 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(6798 2573)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "download_my_resume",
    "data-name": "download my resume",
    transform: "translate(-6786 -2569)",
    fill: "#f2f2f2",
    fontSize: 20,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "download my resume")), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 26,
    transform: "translate(-6797.5 -2572.5)",
    fill: "none",
    stroke: "#df5757",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y1: 26,
    transform: "translate(-6771.5 -2572.5) rotate(90)",
    fill: "none",
    stroke: "#df5757",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 26,
    transform: "translate(-6797.5 -2572.5)",
    fill: "none",
    stroke: "red",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y1: 26,
    transform: "translate(-6771.5 -2572.5) rotate(90)",
    fill: "none",
    stroke: "red",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-13181 -5081.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 26,
    transform: "translate(-6594.5 -2545.5)",
    fill: "none",
    stroke: "red",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 26,
    transform: "translate(-6568.5 -2545.5) rotate(90)",
    fill: "none",
    stroke: "red",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 26,
    transform: "translate(-6594.5 -2545.5)",
    fill: "none",
    stroke: "red",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y1: 26,
    transform: "translate(-6568.5 -2545.5) rotate(90)",
    fill: "none",
    stroke: "red",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22);
export default __webpack_public_path__ + "static/media/Group 22.f366adf172e764fdf27345be53361f7b.svg";
export { ForwardRef as ReactComponent };